var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdScanned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M191.7,66.7c-4.6,0-8.3-3.7-8.3-8.3V25c0-4.6-3.7-8.3-8.3-8.3h-33.3c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3 H175c13.8,0,25,11.2,25,25v33.3C200,62.9,196.3,66.7,191.7,66.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M175,200h-33.3c-4.6,0-8.3-3.7-8.3-8.3c0-4.6,3.7-8.3,8.3-8.3H175c4.6,0,8.3-3.7,8.3-8.3v-33.3 c0-4.6,3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3V175C200,188.8,188.8,200,175,200z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M58.3,200H25c-13.8,0-25-11.2-25-25v-33.3c0-4.6,3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3V175 c0,4.6,3.7,8.3,8.3,8.3h33.3c4.6,0,8.3,3.7,8.3,8.3C66.5,196.2,62.9,200,58.3,200z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M8.3,66.7C3.7,66.7,0,63,0,58.4V25C0,11.2,11.2,0,25,0h33.3c4.6,0,8.3,3.7,8.3,8.3c0,4.6-3.7,8.3-8.3,8.3H25 c-4.6,0-8.3,3.7-8.3,8.3v33.3C16.7,62.9,12.9,66.7,8.3,66.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M150,91.7c-4.6,0-8.3-3.7-8.3-8.3v-25H58.3v25c0,4.6-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3v-25 c0-9.2,7.5-16.7,16.7-16.7h83.3c9.2,0,16.7,7.5,16.7,16.7v25C158.3,87.9,154.6,91.7,150,91.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M175,116.7c0,4.6-3.7,8.3-8.3,8.3h-8.3v16.7c0,9.2-7.5,16.7-16.7,16.7H58.3c-9.2,0-16.7-7.5-16.7-16.7V125 h-8.3c-4.6,0-8.3-3.7-8.3-8.3c0-4.6,3.7-8.3,8.3-8.3h133.3C171.3,108.3,175,112.1,175,116.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdScanned);
export default __webpack_public_path__ + "static/media/id-scanned.0849561beb22ccb2ae538a1169353f9c.svg";
export { ForwardRef as ReactComponent };